
import React, {useEffect, useState} from "react";
import {useParams} from "react-router";
import TenantForm from "./TenantForm";
import {useGetTenantByIdQuery} from "../tenantApi";
import {hasPermission} from "../../../../helpers/utils/AccessControlUtils";

const UpdateTenant = () => {

    const {tenantId} = useParams();
  
    const tenantByIdApi = useGetTenantByIdQuery(tenantId);
    const [crumbs, setCrumbs] = useState<any[]>([]);

    useEffect(() => {
       
            setCrumbs([
                {content: "Home", url: "/home"},
                {content: "Tenants", url: "/tenants"},
                {content: "Update Tenant", url: ""}
            ]);        
    }, [tenantByIdApi]);
    return (
        <>
            <TenantForm crumbs={crumbs} title={"Update Tenant"} btnText={"Update"}
                        isReadOnly={!hasPermission(["TEN-U"])}/>
        </>
    )
}

export default UpdateTenant;
